import { IState } from '../../../store';

export function selectIsEnabledCallTracking(state: IState) {
  return state.offerData.offer.isEnabledCallTracking;
}
